

/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateProtocol 预览表单项协议
 */
import { mixPreviewItemTemplateProtocol } from "@/mixins/preview_item/mix_preview_item_template_protocol.js";


/** mixPreviewItemTemplateProtocol 协议实现
 *  @author 王汝鹏
 *  @version 2019-11-29
 */
export const mixPreviewItemTemplateProtocolRealize = {
  mixins: [ mixPreviewItemTemplateProtocol ],
  computed: {
    /** 协议数据 ::: 
     *  @return {Object} eventMap 事件字典
     *  @return {Object} formMap 表单项字典
     *  @return {Object} formModels 表单填写数据
     *  @return {Object} variableMap 变量设置字典
     *  @return {Boolean} itemPickControl 是否启动表单勾选
     *  @return {Object} pickListState 勾选表单项记录
     */
    preview_item_template_store: { 
      get() {
        let mix_rice_preview_form_store = this.mix_rice_preview_form_store;
        return {
          get eventMap() { return mix_rice_preview_form_store.eventMap; },
          get formMap() { return mix_rice_preview_form_store.formMap; },
          get formModels() { return mix_rice_preview_form_store.formModels; },
          set formModels(newValue) { mix_rice_preview_form_store.formModels = newValue; },
          get variableMap() { return mix_rice_preview_form_store.variableMap; },
          get itemPickControl () { return mix_rice_preview_form_store.itemPickControl; },
          get pickListState () { return mix_rice_preview_form_store.pickListState; },
          set pickListState ( newValue ) { mix_rice_preview_form_store.pickListState = newValue; },
          get variableMap () {return mix_rice_preview_form_store.variableMap;},
          get toggleClearModelState () { return mix_rice_preview_form_store.toggleClearModelState; },
          set toggleClearModelState ( newValue) { mix_rice_preview_form_store.toggleClearModelState = newValue },
        }
      }
    },
    /** 协议方法 ::: 
     *  @function preview_item_template_node_action_manager 节点行为管理者
     */
    preview_item_template_node_action_manager: { get() { return this.nodeActionManager; } }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/rice_preview_form/mix_rice_preview_form_protocol_realize.js